import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ButtonComponent } from '@catch/general-ui';
import { ToastsService } from '@catch/services';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformInvitation } from '../../../../models/platform.models';
import { PlatformApplyWithProfileService } from '../../../../services/platform-apply-with-profile.service';
import { PlatformDashboardService } from '../../../../services/platform-dashboard.service';
import { PlatformJobsService } from '../../../../services/platform-jobs.service';

@Component({
  selector: 'app-platform-dashboard-invitation-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, ButtonComponent, FontAwesomeModule, TranslocoPipe],
  templateUrl: './platform-dashboard-invitation-item.component.html',
  styleUrl: './platform-dashboard-invitation-item.component.scss',
})
export class PlatformDashboardInvitationItemComponent {
  private readonly dashboard = inject(PlatformDashboardService);
  private readonly jobs = inject(PlatformJobsService);
  private readonly applyWithProfile = inject(PlatformApplyWithProfileService);
  private readonly toastsService = inject(ToastsService);

  readonly invitation = input.required<PlatformInvitation>();

  readonly icons = {
    check: faCheck,
    times: faTimes,
  };

  /**
   * Opens the apply-with-profile modal for an invitation.
   */
  accept(): void {
    this.applyWithProfile.open(
      this.jobs.applyContextFromInvitation(this.invitation())
    );
  }

  /**
   * Declines the invitation in the list.
   */
  decline(): void {
    this.dashboard.declineInvitation(this.invitation().id);
    this.toastsService.info(
      'jobboard.platform.dashboard.invitations.toast-declined'
    );
  }
}
